import PropTypes from "prop-types";
import { useState } from "react";

import { TableCell, TableRow } from "@mui/material";
import { formateDate } from "src/utils";

// ----------------------------------------------------------------------

ReportTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
};

export default function ReportTableRow({ row, selected }) {
  const [openPopover, setOpenPopover] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell align="left">{row.report ?? "-"} </TableCell>
        <TableCell align="left">{row.program_name ?? "-"} </TableCell>
        <TableCell align="left">{row.user_name ?? "-"} </TableCell>
        <TableCell align="left">{formateDate(row.createdOn ?? "-")} </TableCell>
        <TableCell align="left">{row.sent_to_parent ?? "-"} </TableCell>
        <TableCell align="left">{row.report_link ?? "-"} </TableCell>
      </TableRow>
    </>
  );
}
